module.exports = __webpack_public_path__ + "img/CH01-012-013.3c4a6be8.jpg";